/**
 *
 * @param id
 * @param path
 * @param hiddenTitleInputName
 * @param defaultId
 * @param defaultText
 * @param selectValue
 * @param preOptions
 */
function addSelect2(id, path, hiddenTitleInputName, defaultId, defaultText, selectValue, preOptions)
{
    defaultId = typeof defaultId !== 'undefined' ? defaultId : '';
    defaultText = typeof defaultText !== 'undefined' ? defaultText : 'Escriu...';
    selectValue = typeof selectValue !== 'undefined' ? selectValue : null;

    $('.' + id).select2({
        ajax: {
            type: 'POST',
            delay: 500,
            url: path,
            processResults: function (data) {
                var options = [];

                $.map(preOptions, function(obj) {
                    options.push({ id: obj.id, text: obj.text });
                });

                $.map(data.results, function(obj) {
                    options.push({ id: obj.id, text: obj.text });
                });

                return {
                    results: options
                };

            },
            data: function (params) {
                var data = {
                    term: params.term
                };

                if (selectValue !== null && $('.'+selectValue).val()) {
                    data.filter_id = $('.'+selectValue).val();
                }

                return data;
            }
        },
        placeholder: {
            id: defaultId,
            text: defaultText
        }
    });

    $('.' + id).on('select2:select', function (e) {
        var data = e.params.data;
        $('input[name="'+ hiddenTitleInputName + '"]').val(data.text);
    });
}